import Vue from 'vue'
import Vuex from 'vuex'
import { homePage } from '@/Apis/functions/user'
import {isMobile} from '@/libs/user_utils'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuBar: null,
    advertisement: null,
    advertisingVideo: null,
    newsCenter: null,
    cooperativePartner: null
  },
  mutations: {
    setHomeData (state, {menuBar,advertisement,advertisingVideo,newsCenter,cooperativePartner}) {
      state.menuBar = menuBar
      state.advertisement = advertisement
      state.advertisingVideo = advertisingVideo
      state.newsCenter = newsCenter
      state.cooperativePartner = cooperativePartner
    },
  },
  actions: {
    handleHomeData ({ commit }) {
      let param = {
        merchantId: 'dwj',
        terminal: isMobile ? 'H5' : 'PC'
      }
      homePage(param).then(res => {
        if (res.status === 200) {
          let data = res.data || {}
          commit('setHomeData', data)
        }
      })
    }
  }
})
